/*-----------------------------------------------------------------
- User Routes
-----------------------------------------------------------------*/
const prefix = 'shipping';

const routes = [
    // Create
    {
        path     : `${prefix}/create`,
        name     : `${prefix}-create`,
        component: () => import(/* webpackChunkName: "shipping" */ '@/modules/shipping/views/Edit'),
    },
    
    // Edit
    {
        path     : `${prefix}/:id/edit`,
        name     : `${prefix}-edit`,
        component: () => import(/* webpackChunkName: "shipping" */ '@/modules/shipping/views/Edit'),
    },
];

export default routes;
